module.exports = __webpack_public_path__ + "static/dorcol-7ac15c4b67a3c7022bee126021c1aa47.jpg";